import React from 'react';

const Spinner = () => {
  return (
    <div className="h-[400px] w-full flex items-center justify-center">
        <div className="w-[30px] h-[30px] flex items-center justify-center gap-[4px] mx-auto">
            {[1, 2, 3, 4, 5].map((_, index) => (
                <div 
                    key={index}
                    className="w-[6px] h-full animate-random-swing rounded-t-[2px]"
                    style={{ 
                        backgroundColor: `hsl(${Math.floor(Math.random() * 360)}, 70%, 75%)`,
                        animationDelay: `${index * 0.15}s`,
                        transformOrigin: 'center'
                    }} 
                />
            ))}
        </div>
    </div>
  )
};

export default Spinner;